$( '.click_tab' ).click(function(event) {
    event.preventDefault();
    $( '.click_tab' ).removeClass('active');
    $( this ).addClass('active');
    var for_id = $(this).attr('data-for');
    $('.calc_box_wrap').removeClass('active');
    $('#' + for_id ).addClass('active');
});




$('.form_calc_smoke input, .form_calc_smoke select').change(function() {
    var val_1_wide          =  $('#input_1_wide').val();
    var val_1_length        =  $('#input_1_length').val();
    var val_1_is_sprinklers =  $('#input_1_is_sprinklers').val();
    var sum                 = (val_1_wide * val_1_length * val_1_is_sprinklers);
    if (sum > 0){
        $('#input_1_sum').val(sum);
    }
});
$('.form_calc_air input, .form_calc_air select').change(function() {
    var input_2_square      =  $('#input_2_square').val();
    var input_2_height      =  $('#input_2_height').val();
    var input_2_changes     =  $('#input_2_changes').val();
    var sum = (input_2_square * input_2_height * input_2_changes);
    if (sum > 0){
        $('#input_2_sum').val(sum);
    }
});